import { SET_CURRENT_SESSION, CLEAR_CURRENT_SESSION } from "../actions";

export default function currentSession(state = "", action) {
  switch (action.type) {
    case SET_CURRENT_SESSION:
      return action.payload;
    case CLEAR_CURRENT_SESSION:
      return "";
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/currentSession.js